import React, { useId, useState } from 'react';
import { ChevronDown, ChevronRight, Info } from 'lucide-react';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';

export default function CollapsibleSection({ title, tooltip, badge, children }) {
  const [expanded, setExpanded] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const contentId = useId();

  const handleTooltipPointerDown = (event) => {
    if (event.pointerType !== 'touch') return;

    event.preventDefault();
    setTooltipOpen((open) => !open);
  };

  return (
    <div>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => setExpanded((open) => !open)}
            aria-controls={contentId}
            aria-expanded={expanded}
            aria-label={`${expanded ? 'Collapse' : 'Expand'} ${title}`}
            className="h-8 w-8 shrink-0 p-0 text-slate-500 hover:bg-slate-100 dark:text-gray-400 dark:hover:bg-white/[0.05]"
          >
            {expanded ? <ChevronDown className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
          </Button>
          <div className="flex min-w-0 items-center gap-1.5">
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white">{title}</h3>
            <TooltipProvider>
              <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
                <TooltipTrigger asChild>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onPointerDown={handleTooltipPointerDown}
                    onClick={(event) => event.preventDefault()}
                    aria-label={`About ${title}`}
                    className="h-7 w-7 shrink-0 rounded-full p-0 text-slate-500 hover:bg-slate-100 dark:text-gray-400 dark:hover:bg-white/[0.05]"
                  >
                    <Info className="h-4 w-4" aria-hidden="true" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="max-w-md text-left leading-relaxed">
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
        {badge}
      </div>
      {expanded && <div id={contentId}>{children}</div>}
    </div>
  );
}
